import ModalBaseChildrenWrapper from './ModalBaseChildrenWrapper';

export default ModalBaseChildrenWrapper;
